/* Deck builder engine (no page code here, so it can be tested on its own).
   Reads decklists in the common formats of every card game and matches them against the store's
   stock list (published by the Store App: {v, img, games, cards: [[title, handle, game, set, image,
   [[variantId, variantTitle, priceCents, qty]...]]...]}). Works for any game whose listings are titled
   "Name (extras) (number) (SET)", so new games need no change here.
   Decklist formats understood:
     4 Lightning Bolt | 4x Lightning Bolt | Lightning Bolt (= 1)
     1 Sol Ring (C21) 263 [*F*]          Moxfield / MTG Arena (set + collector number, foil mark)
     4 Pikachu ex SVI 63                 Pokemon TCG Live (set code + number)
     4xOP01-016 | 4 OP01-016             One Piece (card code)
     3 | Luke Skywalker | Faithful Friend   Star Wars Unlimited (name | subtitle)
     SB: 2 Duress, "Sideboard" / "Maybeboard" sections, "Pokemon: 12"-style headings, // and # comments */
(function (root) {
  "use strict";
  var COND = [["near mint", 5, "NM"], ["lightly played", 4, "LP"], ["moderately played", 3, "MP"], ["heavily played", 2, "HP"], ["damaged", 1, "DM"]];

  function strip(s) { return String(s || "").normalize("NFKD").replace(/[̀-ͯ]/g, ""); }
  // name key: lower case, accents and punctuation gone, "-" "|" "," "'" treated alike
  function key(s) {
    return strip(s).toLowerCase().replace(/[’‘`]/g, "'").replace(/'/g, "")
      .replace(/\s*\/\/\s*/g, " // ").replace(/[^a-z0-9/ ]+/g, " ").replace(/\s+/g, " ").trim();
  }
  function numKey(n) {   // "054/252" -> "54", "OP05-010" -> "op05-010", "RA8" -> "ra8"
    var s = String(n || "").toLowerCase().trim();
    if (/^\d+\/\d+$/.test(s)) s = s.split("/")[0];
    if (/^\d+[a-z]?$/.test(s)) s = s.replace(/^0+(?=\d)/, "");
    return s;
  }
  var CODE = /^[A-Za-z]{1,5}\d{0,3}[A-Za-z]?-[A-Za-z]{0,2}\d{2,4}[A-Za-z]?$/;   // OP01-016, LOD-013, DB1-EN178, ST19-002

  /* "Bianca (147 Full Art) (147/149) (BCR)" -> { name: "Bianca", extras: ["147 Full Art"], number: "147/149", set: "BCR" } */
  function parseTitle(t) {
    var s = String(t || "").trim(), groups = [], m;
    while ((m = /\s*\(([^()]*)\)\s*$/.exec(s)) && m.index > 0) { groups.unshift(m[1].trim()); s = s.slice(0, m.index); }
    var out = { name: s.trim(), extras: [], number: "", set: "" };
    if (groups.length) out.set = groups.pop();
    if (groups.length && /\d/.test(groups[groups.length - 1]) && !/\s/.test(groups[groups.length - 1])) out.number = groups.pop();
    out.extras = groups;
    return out;
  }
  function splitVariant(t) {   // "Lightly Played - Foil" -> { cond: "Lightly Played", rank: 4, short: "LP", finish: "Foil", foil: true }
    var s = String(t || ""), i = s.indexOf(" - "), c = i < 0 ? s : s.slice(0, i), f = i < 0 ? "" : s.slice(i + 3);
    var cl = c.toLowerCase().trim(), r = 0, sh = c;
    for (var k = 0; k < COND.length; k++) if (cl === COND[k][0]) { r = COND[k][1]; sh = COND[k][2]; }
    return { cond: c, rank: r || 3, short: sh, finish: f, foil: /foil/i.test(f) };
  }

  /* ---------- the stock list ---------- */
  function Stock(data) {
    this.data = data; this.cards = [];
    this.byName = new Map(); this.byNum = new Map(); this.byCode = new Map();
    var self = this;
    (data.cards || []).forEach(function (c, i) {
      var p = parseTitle(c[0]);
      var card = { i: i, title: c[0], handle: c[1], game: c[2], setName: c[3], image: c[4] ? (data.img || "") + c[4] : "", name: p.name, extras: p.extras, number: p.number, set: p.set,
        variants: (c[5] || []).map(function (v) { var sv = splitVariant(v[1]); return { id: v[0], title: v[1], cents: v[2], qty: v[3], cond: sv.cond, rank: sv.rank, short: sv.short, finish: sv.finish, foil: sv.foil }; }) };
      self.cards.push(card);
      var add = function (map, k) { if (!k) return; var l = map.get(k); if (!l) map.set(k, l = []); if (l.indexOf(card) < 0) l.push(card); };
      var nk = key(p.name);
      add(self.byName, nk);
      if (nk.indexOf(" // ") > 0) add(self.byName, nk.split(" // ")[0]);           // front face of a two-sided card
      var dash = /^(.+?)\s+-\s+(.+)$/.exec(p.name);                                   // "Name - Subtitle": "Name" alone too (lower priority)
      if (dash) add(self.byName, "~" + key(dash[1]));
      if (p.number) {
        add(self.byNum, key(p.set) + "|" + numKey(p.number));
        if (CODE.test(p.number)) add(self.byCode, p.number.toLowerCase());
      }
      if (CODE.test(p.name.split(" - ").pop())) add(self.byCode, p.name.split(" - ").pop().toLowerCase());
    });
  }
  Stock.prototype.games = function () { return this.data.games || {}; };

  /* ---------- decklists ---------- */
  var SIDE = /^(sideboard|side ?board|maybeboard|maybe ?board|considering|tokens?|outside the game)\b/i;
  var MAIN = /^(deck|main ?deck|main ?board|mainboard|commander|companion|leader|base|pok[eé]mon|trainers?|energ(y|ies)|monsters?|spells?|traps?|extra ?deck|units?|events?|upgrades?|characters?|stages?|don)\b/i;
  function parseList(text) {
    var out = [], section = "main";
    String(text || "").split(/\r?\n/).forEach(function (raw, ln) {
      var s = raw.replace(/\t/g, " ").trim();
      if (!s) return;
      if (/^(#|\/\/(?!\s*\S+\s*\/\/))/.test(s)) return;                         // comments
      s = s.replace(/^[*•\-–]\s+/, "");
      var sb = /^SB:\s*/i.exec(s); if (sb) { s = s.slice(sb[0].length); }
      // headings: "Sideboard", "Sideboard (15)", "Pokémon: 12", "Deck", "Total Cards: 60"
      var h = s.replace(/[:\s]*\(?\d*\)?\s*$/, "").replace(/:$/, "");
      if (/^total( cards)?\b/i.test(s)) return;
      if (SIDE.test(h) && h.length < 25 && !/^\d/.test(s)) { section = "side"; return; }
      if (MAIN.test(h) && (h.length < 20) && !/^\d/.test(s) && (/:/.test(s) || /^\w+( \w+)?$/.test(s))) { section = "main"; return; }
      var qty = 1, m;
      if ((m = /^(\d{1,3})\s*[xX×]?\s*(\S.*)$/.exec(s))) { qty = Number(m[1]); s = m[2]; }
      else if ((m = /^(.*\S)\s+[xX×]\s*(\d{1,3})$/.exec(s))) { qty = Number(m[2]); s = m[1]; }
      if (!qty) return;
      s = s.replace(/^\|\s*/, "");
      var e = { line: ln + 1, raw: raw.trim(), qty: qty, side: !!sb || section === "side", name: "", set: "", number: "", code: "", foil: false };
      if (/\s\*F\*\s*$/i.test(s) || /\s\*E\*\s*$/i.test(s)) { e.foil = true; s = s.replace(/\s\*[FE]\*\s*$/i, ""); }
      s = s.replace(/\s+\[[^\]]*\]\s*$/, "").replace(/\s+\^[^^]*\^\s*$/, "");      // Moxfield tags [..] ^..^
      if (CODE.test(s.replace(/\s+/g, ""))) { e.code = s.replace(/\s+/g, "").toLowerCase(); out.push(e); return; }
      // "Sol Ring (C21) 263"  /  "Lightning Bolt (2X2) 117"
      if ((m = /^(.*\S)\s+\(([A-Za-z0-9]{2,8})\)\s+([A-Za-z0-9★\-\/]+)$/.exec(s))) { e.name = m[1]; e.set = m[2]; e.number = m[3]; }
      else if ((m = /^(.*\S)\s+\(([A-Za-z0-9]{2,8})\)$/.exec(s))) { e.name = m[1]; e.set = m[2]; }
      // "Pikachu ex SVI 63"  (tried as a plain name too, see match())
      else if ((m = /^(.*\S)\s+([A-Z][A-Z0-9]{1,5}(?:-[A-Z0-9]{1,4})?)\s+(\d{1,3}[a-z]?)$/.exec(s))) { e.name = s; e.alt = { name: m[1], set: m[2], number: m[3] }; }
      else e.name = s;
      e.name = e.name.replace(/\s*\|\s*/g, " - ").trim();
      out.push(e);
    });
    return out;
  }

  /* ---------- matching ---------- */
  // opts: { game: "" | id, minRank: 1-5, finish: "any"|"nonfoil"|"foil", printing: "cheapest"|"listed", sideboard: true }
  Stock.prototype.candidates = function (e, game) {
    var self = this, pick = function (l) { return (l || []).filter(function (c) { return !game || c.game === game; }); };
    var exact = [], names = [];
    if (e.code) { exact = pick(self.byCode.get(e.code)); return { exact: exact, cards: exact }; }
    var tryOne = function (name, set, number) {
      var ex = set && number ? pick(self.byNum.get(key(set) + "|" + numKey(number))) : [];
      var k = key(name), l = pick(self.byName.get(k));
      if (!l.length) l = pick(self.byName.get("~" + k));
      if (set && !number) ex = l.filter(function (c) { return key(c.set) === key(set); });
      // the printing must also have the right name when the list gave one
      if (ex.length && name) { var ok = ex.filter(function (c) { return l.indexOf(c) >= 0 || key(c.name).indexOf(k) === 0; }); if (ok.length) ex = ok; }
      return { exact: ex, cards: l.length ? l : ex };
    };
    var r = tryOne(e.name, e.set, e.number);
    if (!r.cards.length && e.alt) r = tryOne(e.alt.name, e.alt.set, e.alt.number);
    return r;
  };
  Stock.prototype.match = function (list, opts) {
    opts = opts || {};
    var self = this, minRank = opts.minRank || 1, used = new Map(), rows = [];
    var lines = list.filter(function (e) { return opts.sideboard !== false || !e.side; });
    lines.forEach(function (e) {
      var c = self.candidates(e, opts.game || "");
      var listed = opts.printing === "listed" && (c.exact.length || e.foil);
      var options = [];
      c.cards.concat(c.exact.filter(function (x) { return c.cards.indexOf(x) < 0; })).forEach(function (card) {
        var isExact = c.exact.indexOf(card) >= 0;
        card.variants.forEach(function (v) {
          if (v.rank < minRank) return;
          if (opts.finish === "foil" && !v.foil) return;
          if (opts.finish === "nonfoil" && v.foil) return;
          var left = v.qty - (used.get(v.id) || 0);
          if (left <= 0) return;
          var pref = (listed && c.exact.length && isExact ? 0 : 1) + (listed && e.foil && !v.foil ? 1 : 0);
          options.push({ card: card, v: v, left: left, pref: pref, exact: isExact });
        });
      });
      options.sort(function (a, b) { return a.pref - b.pref || (a.v.cents == null ? 1e9 : a.v.cents) - (b.v.cents == null ? 1e9 : b.v.cents) || b.v.rank - a.v.rank || a.card.title.localeCompare(b.card.title); });
      var need = e.qty, picks = [];
      for (var i = 0; i < options.length && need > 0; i++) {
        var o = options[i], n = Math.min(need, o.left);
        picks.push({ card: o.card, v: o.v, n: n, exact: o.exact });
        used.set(o.v.id, (used.get(o.v.id) || 0) + n);
        need -= n;
      }
      var got = e.qty - need;
      var known = c.cards.length > 0 || c.exact.length > 0;
      rows.push({ e: e, want: e.qty, got: got, picks: picks, cents: picks.reduce(function (a, p) { return a + (p.v.cents || 0) * p.n; }, 0),
        status: got >= e.qty ? "found" : got > 0 ? "partial" : known ? "nostock" : "unknown",
        printingDiffers: opts.printing === "listed" && c.exact.length > 0 && picks.some(function (p) { return !p.exact; }) });
    });
    var sum = { want: 0, got: 0, cents: 0, lines: rows.length, full: 0 };
    rows.forEach(function (r) { sum.want += r.want; sum.got += r.got; sum.cents += r.cents; if (r.status === "found") sum.full++; });
    return { rows: rows, sum: sum };
  };
  function cartItems(result) {
    var m = new Map();
    result.rows.forEach(function (r) { r.picks.forEach(function (p) { m.set(p.v.id, (m.get(p.v.id) || 0) + p.n); }); });
    return Array.from(m.entries()).map(function (x) { return { id: x[0], quantity: x[1] }; });
  }
  function missingText(result) {
    return result.rows.filter(function (r) { return r.got < r.want; })
      .map(function (r) { return (r.want - r.got) + " " + (r.e.code ? r.e.code.toUpperCase() : r.e.name) + (r.e.set ? " (" + r.e.set + ")" + (r.e.number ? " " + r.e.number : "") : ""); }).join("\n");
  }

  var api = { parseTitle: parseTitle, splitVariant: splitVariant, parseList: parseList, Stock: Stock, cartItems: cartItems, missingText: missingText, key: key };
  if (typeof module !== "undefined" && module.exports) module.exports = api; else root.MbgDeck = api;
})(typeof window !== "undefined" ? window : this);
